import {useEffect, useRef} from 'preact/hooks';
import AihcMonitor from './actions';

export const useCptDuration = (id: string, trackData: object) => {
    const durationRef = useRef<number>();
    useEffect(() => {
        try {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        durationRef.current = new Date().getTime();
                    } else {
                        const timestamp = new Date().getTime();
                        if (durationRef.current) {
                            const time = (timestamp - durationRef.current) / 1000;
                            AihcMonitor({
                                action: 'hover',
                                value: `${time}`,
                                ...trackData
                            });
                        }
                    }
                });
            });
            observer.observe(document.getElementById(id));
        } catch (error) {
            console.log(error);
        }
    }, []);
};
